import { render, staticRenderFns } from "./ExpressAssistant.vue?vue&type=template&id=cd1c39aa&scoped=true"
import script from "./ExpressAssistant.vue?vue&type=script&lang=js"
export * from "./ExpressAssistant.vue?vue&type=script&lang=js"
import style0 from "./ExpressAssistant.vue?vue&type=style&index=0&id=cd1c39aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd1c39aa",
  null
  
)

export default component.exports